export default defineNuxtPlugin((nuxtApp) => {
    let body: HTMLElement | null = null
    let headerHeight = 0
    let logoHeight = 0
    let viewportHeight = 0

    nuxtApp.hook('app:mounted', () => {
        body = document.body

        new EfficientScrollListener((scrollY: number) => {
            const logoFixed = scrollY > viewportHeight / 2 - logoHeight + 15
            const scrolledDown = scrollY > viewportHeight - headerHeight

            body?.classList.toggle('fixed-logo', logoFixed)
            body?.classList.toggle('scrolled-down', scrolledDown)
        })

        new EfficientResizeListener(setHeights)
    })

    // update when the page changes
    nuxtApp.hook('page:finish', () => {
        setHeights()
    })

    const setHeights = () => {
        viewportHeight = window.innerHeight
        headerHeight = document.querySelector('.site-header')?.clientHeight || 0
        logoHeight = document.querySelector('.header-logo')?.clientHeight || 0
    }
})
